import { render, staticRenderFns } from "./UnapprovedClients.vue?vue&type=template&id=27b76f01"
import script from "./UnapprovedClients.vue?vue&type=script&lang=js"
export * from "./UnapprovedClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports